// TODO RESOLVE ALL NULL CHECKS

(function () {
  const subSliders = document.querySelectorAll(".slide_round");
  subSliders.forEach((slider) => {
    slider.addEventListener("change", function (e) {
      if (this.checked) {
        document.dispatchEvent(new CustomEvent("subscription-on"));
      } else {
        document.dispatchEvent(new CustomEvent("subscription-off"));
      }
    });
    const initializeSlider = () => {
      if (slider.checked) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("subscription-on"));
        }, 10);
      }
      if (localStorage.getItem("subscription_option") === "yes") {
        slider.checked = true;
        slider.dispatchEvent(new Event("change"));
      }
    };
    document.addEventListener("DOMContentLoaded", initializeSlider());
    document.addEventListener("shopify:section:load", initializeSlider());
  });
})();

if (!customElements.get("byo-controller")) {
  class BYOController extends HTMLElement {
    constructor() {
      super();

      this.cartCurrency = "$";

      this.subAmount = this.dataset.subDiscount
        ? parseInt(this.dataset.subDiscount) / 100
        : 0;
      this.shownMobile = parseInt(this.dataset.mobileEmpty);
      this.shownTotal = parseInt(this.dataset.emptyTotal);

      this.isSub = false;
      this.amountOTP = 0;
      this.amountSub = 0;
      this.maxTier = 0;
      this.products = [];
      this.grantedFreeGifts = [];
      this.selectedFreeGifts = [];
      this.discountPercent = 0
      this.discountFixedAmount = 0
      this.tiers = this.querySelectorAll("byo-tier");
      this.progressBar = this.querySelector(".progress-bar");
      this.progressWrapper = this.querySelector(".progress-container");
      this.addToCart = this.querySelector(".add_bundle_cart");
      this.cartPrice = this.querySelector(".cart_price");

      this.productTemplate = this.querySelector("#bundle-item");
      this.emptyTemplate = this.querySelector("#bundle-item--empty");
      this.emptyBuilderMessage = this.querySelector(".without_img_text");
      this.builderContents = this.querySelector(".bundleproducts");
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
        this.attachAdditionalListeners();
        this.getDependantData();
        this.intializeSetVariables();
        this.setupObservers();
        this.setupAdditionalObservers();
      });
    }
    attachAdditionalListeners() {}
    setupAdditionalObservers() {}
    attachListeners() {
      document.addEventListener(
        "update-bundle-item",
        this.updateBundleItem.bind(this)
      );
      document.addEventListener(
        "remove-from-bundle",
        this.removeBundleItem.bind(this)
      );
      document.addEventListener("add-to-bundle", this.addBundleItem.bind(this));
      document.addEventListener("subscription-on", () => {
        this.isSub = true;
        this.updateUI();
      });
      document.addEventListener("subscription-off", () => {
        this.isSub = false;
        this.updateUI();
      });
      document.addEventListener(
        "granted-free-gift",
        this.addGrantedFreeGift.bind(this)
      );
      document.addEventListener(
        "remove-granted-free-gift",
        this.removeGrantedFreeGift.bind(this)
      );
      document.addEventListener(
        "selected-free-gift",
        this.addSelectedFreeGift.bind(this)
      );
      document.addEventListener(
        "remove-selected-free-gift",
        this.removeSelectedFreeGift.bind(this)
      );
      this.addToCart.addEventListener('click', this.handleAddToCart.bind(this))
    }
    addBundleItem({ detail }) {
      this.products.push(detail);
      this.updateUI();
    }
    updateBundleItem({ detail }) {
      const matchingProduct = this.products.find(
        (product) => product.id == detail.id
      );
      if (matchingProduct) {
        matchingProduct.quantity = detail.quantity;
      }
      this.updateUI();
    }
    removeBundleItem({ detail }) {
      const matchingProduct = this.products.find(
        (product) => product.id == detail.id
      );
      if (matchingProduct) {
        this.products.splice(this.products.indexOf(matchingProduct), 1);
      }
      this.updateUI();
    }
    updateUI() {
      this.updateAmount();
      this.updateBoxUI();
      this.updateDiscount()
      this.updateButton();
      this.updateTiers();
      this.updateProgressBar();
      this.updateSavedData();
    }
    updateAmount() {
      this.amountOTP = 0;
      this.amountSub = 0;
      this.products.forEach((prod) => {
        if(prod.sub != 'false') {
          this.amountSub = this.amountSub + parseInt(prod.price) * prod.quantity;
        } else {
          this.amountOTP = this.amountOTP + parseInt(prod.price) * prod.quantity;
        }
      })
      this.amountOTP = this.amountOTP > 0 ? this.amountOTP/100 : 0;
      this.amountSub = this.amountSub > 0 ? this.amountSub/100 : 0;
      
      this.amount =
        this.products.reduce(
          (prev, next) => prev + parseInt(next.price) * next.quantity,
          0
        ) / 100;
      this.amount = this.amount.toFixed(2);
    }
    updateBoxUI() {
      const totalProductCount =
        this.products.length +
        this.grantedFreeGifts.length +
        this.selectedFreeGifts.length;
      const template = this.productTemplate.content.cloneNode(true);
      // TODO get this moved out to the proper location
      const contents = document.querySelector(".bundleproducts");
      const messageContainer = document.querySelector(".without_img_text");
      if (totalProductCount === 0) {
        messageContainer.classList.remove("hide_button");
      } else {
        messageContainer.classList.add("hide_button");
      }

      contents.innerHTML = "";
      if (totalProductCount < this.shownTotal) {
        this.setBoxesToShow(contents, totalProductCount);
      }
      this.products.forEach((product) => {
        const newProduct = template.firstElementChild.cloneNode(true);
        newProduct.classList.add(`product_box_${product.id}`);
        newProduct.querySelector("img").src = product.image;
        newProduct.querySelector(".qty_wrapper").innerText = product.quantity;
        newProduct.querySelector(".top_free").classList.add("hide_button");
        newProduct.querySelector("a").innerText = product.title;
        newProduct.querySelector(".top_icon").addEventListener("click", () => {
          document.dispatchEvent(
            new CustomEvent("removed-from-box", {
              detail: {
                id: product.id,
              },
            })
          );
        });
        contents.prepend(newProduct);
      });

      const gifts = this.grantedFreeGifts.concat(this.selectedFreeGifts);
      gifts.forEach((product) => {
        const newProduct = template.firstElementChild.cloneNode(true);
        newProduct.classList.add(`product_box_${product.id}`);
        newProduct.querySelector("img").src = product.image;
        newProduct.querySelector(".icon_qty").classList.add("hide_button");
        newProduct.querySelector("a").innerText = product.title;
        newProduct.querySelector(".top_icon").classList.add("hide_button");
        contents.prepend(newProduct);
      });
    }
    setBoxesToShow(totalProductCount) {
      // TODO TEST THIS FOR POSSIBLE ISSUES
      const emptyTemplate = this.emptyTemplate.content.cloneNode(true);
      if (this.shownMobile <= totalProductCount) {
        for (let i = 0; i < this.shownTotal - totalProductCount; i++) {
          const emptyItem = emptyTemplate.firstElementChild.cloneNode(true);
          emptyItem.classList.add("hidemobile");
          contents.appendChild(emptyItem);
        }
      } else {
        for (let i = 0; i < this.shownTotal - totalProductCount; i++) {
          const emptyItem = emptyTemplate.firstElementChild.cloneNode(true);
          if (
            (!totalProductCount && i + 1 <= this.shownMobile) ||
            totalProductCount
          ) {
            emptyItem.classList.add("hidemobile");
          }
          contents.appendChild(emptyItem);
        }
      }
    }
    updateDiscount() {
      this.discountPercent = 0
      this.discountFixedAmount = 0
      let activeDiscount = [...this.tiers].reduce(
        (discountTier, currentTier) => {
          if (
            currentTier.tierType == "discount" &&
            currentTier.tierAmount <= this.amount &&
            (!discountTier || currentTier.tierAmount > discountTier.tierAmount)
          ) {
            return currentTier;
          }
          return discountTier;
        }
      );
      if (!activeDiscount || activeDiscount.tierType != "discount") return
      if(activeDiscount.discountPercent > 0) {
        this.discountPercent = activeDiscount.discountPercent
      } else if(activeDiscount.discountFixedAmount > 0) {
        this.discountFixedAmount = activeDiscount.discountFixedAmount
      }
    }
    updateButton() {
      if (this.cartPrice) {
        this.cartPrice.innerHTML = this.getButtonText();
      }
    }
    getButtonText() {
      let finalPrice = 0
      let priceHtml = `
        <ins>${this.cartCurrency}${this.amount}</ins>
      `;

      if (this.isSub && this.amount > 0) {
        finalPrice = this.amountOTP + (this.amountSub * (1 - this.subAmount));
      } else if(this.discountPercent > 0 && this.amount > 0){
        finalPrice = (this.amount * (100 - this.discountPercent)/100)
      } else if(this.discountFixedAmount > 0 && this.amount > 0){
        finalPrice = (this.amount - this.discountFixedAmount)
      }

      if(finalPrice != 0) {
        priceHtml = `
          <del>
            ${this.cartCurrency}
            ${this.amount}
          </del>
          <ins>${this.cartCurrency}${finalPrice.toFixed(2)}</ins>
        `;
      }

      return priceHtml;
    }
    updateTiers() {
      const appliedTiers = this.selectedFreeGifts
        .concat(this.grantedFreeGifts)
        .map((item) => item.tier);
      this.tiers.forEach((tier) => {
        tier.maybeApplyTier(this.amount, appliedTiers);
      });
    }
    setupObservers() {
      const resizeObserver = new ResizeObserver((entries) => {
        this.updateProgressBar();
      });

      resizeObserver.observe(document.querySelector("body"));
    }
    updateProgressBar() {
      if (this.progressBar && this.progressWrapper) {
        const nextUnappliedTier = [...this.tiers].find(
          (tier) => !tier.getTierApplied()
        );
        if (nextUnappliedTier) {
          const nextUnappliedTierIndex = [...this.tiers].indexOf(
            nextUnappliedTier
          );
          const tierIndex = nextUnappliedTierIndex + 1;
          const maxSize =
            (1 / [...this.tiers].length).toFixed(2) *
            tierIndex *
            this.progressWrapper.offsetWidth;
          const amountFilled = this.amount / nextUnappliedTier.getTierAmount();

          this.progressBar.style = `background:#ea2829;width: ${
            maxSize * amountFilled
          }px`;
        } else {
          this.progressBar.style = `background:#ea2829;width: 100%;`;
        }
      }
    }
    addGrantedFreeGift({ detail }) {
      const matchingProduct = this.grantedFreeGifts.find(
        (product) => product.tier == detail.tier
      );
      if (!matchingProduct) {
        this.grantedFreeGifts.push(detail);
      }
      this.updateBoxUI();
      this.updateSavedData();
    }
    removeGrantedFreeGift({ detail }) {
      const matchingProduct = this.grantedFreeGifts.find(
        (product) => product.tier == detail.tier
      );
      if (matchingProduct) {
        this.grantedFreeGifts.splice(
          this.grantedFreeGifts.indexOf(matchingProduct),
          1
        );
      }
      this.updateBoxUI();
      this.updateSavedData();
    }
    addSelectedFreeGift({ detail }) {
      const matchingProduct = this.selectedFreeGifts.find(
        (product) => product.tier == detail.tier
      );
      if (!matchingProduct) {
        this.selectedFreeGifts.push(detail);
      }
      this.updateBoxUI();
      this.updateSavedData();
    }
    removeSelectedFreeGift({ detail }) {
      const matchingProduct = this.selectedFreeGifts.find(
        (product) => product.tier == detail.tier
      );
      if (matchingProduct) {
        this.selectedFreeGifts.splice(
          this.selectedFreeGifts.indexOf(matchingProduct),
          1
        );
      }
      this.updateBoxUI();
      this.updateSavedData();
    }
    getDependantData() {
      this.tiers.forEach((tier) => {
        const tierAmount = tier.getTierAmount();
        if (this.maxTier < tierAmount) {
          this.maxTier = tierAmount;
        }
      });
    }
    handleAddToCart() {
      const items = [];
      this.grantedFreeGifts.forEach((gift) => {
        items.push({
          id: gift.id,
          quantity: 1,
          properties: {
            _bundle: true,
            _freegift: true,
            _granted: true,
          },
        });
      });
      this.selectedFreeGifts.forEach((gift) => {
        items.push({
          id: gift.id,
          quantity: 1,
          properties: {
            _bundle: true,
            _freegift: true,
            _selectedgift:true
          },
        });
      });
      this.products.forEach((product) => {
        const item = {
          id: product.id,
          quantity: product.quantity,
          properties: {
            _bundle: true,
          },
        };
        if (this.isSub && product.sub != 'false') {
          item.selling_plan = product.sub;
        } else if (product.sub_only == 'true' && product.sub != 'false') {
          item.selling_plan = product.sub;
        }
        items.push(item);
      });
      fetch("/cart/add.js", {
        body: JSON.stringify({ items: items }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "post",
      })
        .then((response) => {
          return response.json();
        })
        .then((body) => {
          this.products = [];
          this.selectedFreeGifts = [];
          this.grantedFreeGifts = [];
          this.updateUI();
          document.dispatchEvent(new CustomEvent("reset-products"));
          window.location.href = "/checkout";
        })
        .catch((err) => {
          console.error(err);
        });
    }
    intializeSetVariables() {
      const grantedFreeGifts = localStorage.getItem("byo-granted-gifts");
      const selectedFreeGifts = localStorage.getItem("byo-selected-gifts");
      const products = localStorage.getItem("byo-products");
      let needsUpdate = false;
      if (grantedFreeGifts) {
        this.grantedFreeGifts = JSON.parse(grantedFreeGifts);
        needsUpdate = true;
      }
      if (selectedFreeGifts) {
        this.selectedFreeGifts = JSON.parse(selectedFreeGifts);
        needsUpdate = true;
      }
      if (products) {
        this.products = JSON.parse(products);
        this.products.forEach((product) => {
          document.dispatchEvent(
            new CustomEvent("product-loaded", {
              detail: {
                id: product.id,
                quantity: product.quantity,
              },
            })
          );
        });
        needsUpdate = true;
      }
      if (needsUpdate) {
        this.updateUI();
      }
    }
    updateSavedData() {
      localStorage.setItem(
        "byo-granted-gifts",
        JSON.stringify(this.grantedFreeGifts)
      );
      localStorage.setItem(
        "byo-selected-gifts",
        JSON.stringify(this.selectedFreeGifts)
      );
      localStorage.setItem("byo-products", JSON.stringify(this.products));
    }
  }
  customElements.define("byo-controller", BYOController);

  class BYOControllerAlt extends BYOController {
    constructor() {
      super();
      this.STICKY_SELECTOR = ".bundles-header.bundles-header--alt";
      this.STICKY_ACTIVE_CLASS = "td--sticky--stuck";

      this.shownTablet = this.dataset.tabletEmpty;
      this.cartPrices = this.querySelectorAll(".cart_price");
      this.maybeHandleSticky();
    }
    // connectedCallback() {
    //   setTimeout(() => {
    //     this.maybeHandleSticky()
    //   })
    // }
    attachAdditionalListeners() {
      this.attachScrollListeners();
      document.addEventListener(
        "bundle-product-added",
        this.handleBundleAdded.bind(this)
      );
    }
    updateButton() {
      this.cartPrices.forEach((button) => {
        button.innerHTML = this.getButtonText();
      });
    }

    setBoxesToShow(contents, totalProductCount) {
      const emptyTemplate = this.emptyTemplate.content.cloneNode(true);
      if (
        this.shownMobile > totalProductCount ||
        this.shownTablet > totalProductCount
      ) {
        for (let i = 0; i < this.shownTotal - totalProductCount; i++) {
          const emptyItem = emptyTemplate.firstElementChild.cloneNode(true);
          if (
            this.shownMobile > totalProductCount &&
            i + totalProductCount >= this.shownMobile
          ) {
            emptyItem.classList.add("hidemobile");
          }
          if (
            this.shownTablet > totalProductCount &&
            i + totalProductCount >= this.shownTablet
          ) {
            emptyItem.classList.add("hidetablet");
          }
          contents.appendChild(emptyItem);
        }
      } else {
        for (let i = 0; i < this.shownTotal - totalProductCount; i++) {
          const emptyItem = emptyTemplate.firstElementChild.cloneNode(true);
          if (
            (!totalProductCount && i + 1 > this.shownMobile) ||
            totalProductCount
          ) {
            emptyItem.classList.add("hidemobile");
          }
          if (
            (!totalProductCount && i + 1 > this.shownTablet) ||
            totalProductCount
          ) {
            emptyItem.classList.add("hidetablet");
          }
          contents.appendChild(emptyItem);
        }
      }
    }
    attachScrollListeners() {
      window.addEventListener("scroll", this.maybeHandleSticky.bind(this));
    }
    maybeHandleSticky() {
      const stickyElement = document.querySelector(this.STICKY_SELECTOR);
      if (stickyElement) {
        const currentOffset = stickyElement.getBoundingClientRect().top;
        const stickyOffset = parseInt(
          getComputedStyle(stickyElement).top.replace("px", "")
        );

        if (currentOffset <= stickyOffset) {
          if (!stickyElement.classList.contains(this.STICKY_ACTIVE_CLASS)) {
            stickyElement.classList.add(this.STICKY_ACTIVE_CLASS);
          }
        } else {
          if (stickyElement.classList.contains(this.STICKY_ACTIVE_CLASS)) {
            stickyElement.classList.remove(this.STICKY_ACTIVE_CLASS);
          }
        }
      }
    }
    handleBundleAdded({ detail }) {
      if (detail.products) {
        detail.products.forEach((detailProduct) => {
          const matchingProduct = this.products.find(
            (product) => product.id == detailProduct.id
          );
          if (matchingProduct) {
            matchingProduct.quantity += detailProduct.quantity;
            document.dispatchEvent(
              new CustomEvent("product-loaded", {
                detail: {
                  id: detailProduct.id,
                  quantity: matchingProduct.quantity,
                },
              })
            );
            this.updateUI();
          } else {
            this.addBundleItem({ detail: detailProduct });

            document.dispatchEvent(
              new CustomEvent("product-loaded", {
                detail: {
                  id: detailProduct.id,
                  quantity: detailProduct.quantity,
                },
              })
            );
          }
        });
      }
    }
  }
  customElements.define("byo-controller-alt", BYOControllerAlt);
}

if (!customElements.get("byo-tier")) {
  class BYOTier extends HTMLElement {
    constructor() {
      super();
      this.indicatorActiveClass = "byo-tier__indicator--active";
      this.tierMet = false;
      this.tierAmount = this.dataset.amount ? parseInt(this.dataset.amount) : 0;
      this.discountPercent = this.dataset.discountPercent ? parseInt(this.dataset.discountPercent) : 0;
      this.discountFixedAmount = this.dataset.discountFixedAmount ? parseInt(this.dataset.discountFixedAmount) : 0;
      this.tierType = this.dataset.type;
      this.forTierId = this.dataset.for;
      this.indicator = this.querySelector("svg");
      this.tierValue = this.querySelector(".tier_value");
    }
    connectedCallback() {
      this.attachListeners();
      this.tierValue = this.querySelector(".tier_value");
    }
    attachListeners() {
      document.addEventListener(
        "selected-free-gift",
        this.maybeHandleGiftSelected.bind(this)
      );
    }
    getTierAmount() {
      return this.tierAmount;
    }
    getTierApplied() {
      return this.tierMet;
    }
    maybeApplyTier(amount, alreadyApplied) {
      if (this.tierMet) {
        if (this.tierAmount > amount) {
          this.undoTier();
          this.tierMet = false;
        }
      } else {
        if (this.tierAmount <= amount) {
          // Checking if it has already been applied to saved data, don't trigger selectors in that event
          this.applyTier(!alreadyApplied.includes(this.forTierId));
          this.tierMet = true;
        }
      }
    }
    applyTier(triggerTierAction) {
      this.indicator.classList.add(this.indicatorActiveClass);
      this.tierValue.classList.add("hide_button");
      if (triggerTierAction) {
        switch (this.tierType) {
          case "free_product":
            this.handleAddFreeProduct();
            break;
          case "select_a_gift":
            this.handleAddSelectAGift();
            break;
        }
      }
    }
    undoTier() {
      this.indicator.classList.remove(this.indicatorActiveClass);
      this.tierValue.classList.remove("hide_button");
      switch (this.tierType) {
        case "free_product":
          this.handleRemoveFreeProduct();
          break;
        case "select_a_gift":
          this.handleRemoveSelectAGift();
          break;
      }
    }
    handleAddFreeProduct() {
      const matchingProduct = document.querySelector(
        `[data-tier="${this.forTierId}"]`
      );
      if (matchingProduct) {
        document.dispatchEvent(
          new CustomEvent("granted-free-gift", {
            detail: {
              tier: this.forTierId,
              id: matchingProduct.dataset.product,
              title: matchingProduct.dataset.title,
              image: matchingProduct.dataset.image,
            },
          })
        );
      }
    }
    handleAddSelectAGift() {
      const modal = document.querySelector(
        `.free_full_size_list[data-tier="${this.forTierId}"]`
      );
      if (modal) {
        modal.classList.remove("dp_none");
        document.querySelector("body").classList.add("body_overflow");
      }
    }
    maybeHandleGiftSelected({ detail }) {
      if (detail.tier === this.forTierId) {
        const modal = document.querySelector(
          `.free_full_size_list[data-tier="${this.forTierId}"]`
        );
        if (modal) {
          modal.classList.add("dp_none");
          document.querySelector("body").classList.remove("body_overflow");
        }
      }
    }
    handleRemoveFreeProduct() {
      document.dispatchEvent(
        new CustomEvent("remove-granted-free-gift", {
          detail: {
            tier: this.forTierId,
          },
        })
      );
    }
    handleRemoveSelectAGift() {
      document.dispatchEvent(
        new CustomEvent("remove-selected-free-gift", {
          detail: {
            tier: this.forTierId,
          },
        })
      );
    }
  }
  customElements.define("byo-tier", BYOTier);
}

if (!customElements.get("byo-product")) {
  class BYOProduct extends HTMLElement {
    constructor() {
      super();
      this.quantity = 0;
      this.minus = this.querySelector(".quantity__minus");
      this.plus = this.querySelector(".quantity__plus");
      this.mainAdd = this.querySelector(".bundle_add");
      this.product = this.dataset.product;
      this.title = this.dataset.title;
      this.image = this.dataset.image;
      this.sub = this.dataset.sub;
      this.sub_only = this.dataset.subOnly;
      this.isAlt = this.classList.contains("byo-product--alt");
    }
    connectedCallback() {
      this.attachListeners();
    }
    attachListeners() {
      if (this.mainAdd) {
        this.mainAdd.addEventListener("click", this.handleMainClick.bind(this));
      }
      if (this.minus) {
        this.minus.addEventListener("click", this.handleMinusClick.bind(this));
      }
      if (this.plus) {
        this.plus.addEventListener("click", this.handlePlusClick.bind(this));
      }
      if(this.sub != 'false') {
        document.addEventListener("subscription-on", () =>
          this.togglePricingUI(true)
        );
        document.addEventListener("subscription-off", () =>
          this.togglePricingUI(false)
        );
      }
      document.addEventListener(
        "removed-from-box",
        this.maybeRemoveItem.bind(this)
      );
      document.addEventListener(
        "product-loaded",
        this.maybeLoadProduct.bind(this)
      );
      document.addEventListener("reset-products", this.resetProduct.bind(this));
    }
    handlePlusClick() {
      this.quantity += 1;
      document.dispatchEvent(
        new CustomEvent("update-bundle-item", {
          detail: {
            id: this.product,
            quantity: this.quantity,
          },
        })
      );
      this.updateUI();
    }
    handleMinusClick() {
      this.quantity -= 1;
      if (this.quantity <= 0) {
        this.quantity = 0;
        document.dispatchEvent(
          new CustomEvent("remove-from-bundle", {
            detail: {
              id: this.product,
            },
          })
        );
      } else {
        document.dispatchEvent(
          new CustomEvent("update-bundle-item", {
            detail: {
              id: this.product,
              quantity: this.quantity,
            },
          })
        );
      }
      this.updateUI();
    }
    handlePreBuiltAdd({ detail }) {
      if (this.product == detail.id) {
        document.dispatchEvent(
          new CustomEvent("add-to-bundle", {
            detail: {
              id: detail.id,
              quantity: detail.quantity,
              price: this.querySelector(`.pprice_${this.product}`).value,
              title: this.title,
              image: this.image,
              sub: this.sub,
              sub_only: this.sub_only
            },
          })
        );
      }
    }
    handleMainClick() {
      if (this.quantity <= 0) {
        this.quantity = 1;
        document.dispatchEvent(
          new CustomEvent("add-to-bundle", {
            detail: {
              id: this.product,
              quantity: 1,
              price: this.querySelector(`.pprice_${this.product}`).value,
              title: this.title,
              image: this.image,
              sub: this.sub,
              sub_only: this.sub_only
            },
          })
        );
        this.updateUI();
      }
    }
    maybeRemoveItem({ detail }) {
      if (detail.id == this.product && this.quantity > 0) {
        this.quantity = 0;
        this.handleMinusClick();
      }
    }
    updateUI() {
      if (this.quantity > 0) {
        this.querySelector(`.cn_${this.product}`).innerText = this.quantity;
        this.querySelector(".quantity__input").value = this.quantity;
        this.querySelector(`.bundle_${this.product}`).classList.add(
          "hide_button"
        );
        this.querySelector(`.qty_${this.product}`).classList.remove(
          "hide_button"
        );
        this.querySelector(`.count_product_${this.product}`).classList.remove(
          "hide_button"
        );
      } else {
        this.querySelector(`.bundle_${this.product}`).classList.remove(
          "hide_button"
        );
        this.querySelector(`.qty_${this.product}`).classList.add("hide_button");
        this.querySelector(`.count_product_${this.product}`).classList.add(
          "hide_button"
        );
      }
    }
    togglePricingUI(isSale) {
      // NOTE assess why this wasn't working after callback
      if (isSale) {
        this.querySelector(".span_sub_price")?.classList.remove("hide_button");
        this.querySelector(".span_org_price")?.classList.add("hide_button");
      } else {
        this.querySelector(".span_sub_price")?.classList.add("hide_button");
        this.querySelector(".span_org_price")?.classList.remove("hide_button");
      }
    }
    maybeLoadProduct({ detail }) {
      if (detail.id == this.product) {
        this.quantity = detail.quantity;
        this.updateUI();
      }
    }
    resetProduct() {
      this.quantity = 0;
      this.updateUI();
    }
  }
  customElements.define("byo-product", BYOProduct);

  class BYOProductBundle extends BYOProduct {
    constructor() {
      super();
      this.STICKY_SELECTOR = ".bundles-header.bundles-header--alt";
      this.STICKY_ACTIVE_CLASS = "td--sticky--stuck";

      this.shownTablet = this.dataset.tabletEmpty;
      this.products = [];
    }
    setProducts() {
      try {
        this.products = JSON.parse(this.dataset.products);
      } catch (err) {
        console.log("Product Bundle - Pre-built item incorrectly configured");
        this.products = [];
      }
    }
    attachListeners() {
      if (this.mainAdd) {
        this.mainAdd.addEventListener(
          "click",
          this.handleBundleClick.bind(this)
        );
      }
      document.addEventListener("subscription-on", () =>
        this.togglePricingUI(true)
      );
      document.addEventListener("subscription-off", () =>
        this.togglePricingUI(false)
      );
    }
    handleBundleClick() {
      this.setProducts();
      document.dispatchEvent(
        new CustomEvent("bundle-product-added", {
          detail: { products: this.products },
        })
      );
    }
  }
  customElements.define("byo-product-bundle", BYOProductBundle);
}

if (!customElements.get("byo-free-product")) {
  class BYOFreeProduct extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define("byo-free-product", BYOFreeProduct);
}
if (!customElements.get("byo-selected-product")) {
  class BYOSelectedProduct extends HTMLElement {
    constructor() {
      super();
      this.tier = this.dataset.tier;
      this.product = this.dataset.product;
      this.title = this.dataset.title;
      this.image = this.dataset.image;
      this.mainAdd = this.querySelector(".bundle_free");
    }
    connectedCallback() {
      this.attachListeners();
    }
    attachListeners() {
      this.mainAdd.addEventListener(
        "click",
        this.handleGiftSelected.bind(this)
      );
    }
    handleGiftSelected() {
      document.dispatchEvent(
        new CustomEvent("selected-free-gift", {
          detail: {
            tier: this.tier,
            id: this.product,
            image: this.image,
            title: this.title,
          },
        })
      );
    }
  }
  customElements.define("byo-selected-product", BYOSelectedProduct);
}

if (!customElements.get("byo-facet")) {
  class BYOFacet extends HTMLElement {
    constructor() {
      super();
      this.collection = this.dataset.collection;
      this.active = this.dataset.active && this.dataset.active != "false";
      this.productList = this.querySelector("product-list");
    }
    connectedCallback() {
      this.attachListeners();
    }
    attachListeners() {
      document.addEventListener(
        "byo-filter-changed",
        this.handleFacetChanged.bind(this)
      );
    }
    handleFacetChanged(e) {
      if (
        e?.detail?.filterVal != this.collection &&
        e?.detail.filterVal.length
      ) {
        this.updateActive(false);
      } else {
        this.updateActive(true);
      }
    }
    updateActive(newActive) {
      if (this.productList) {
        // Theme base custom element has attribute change watcher on hidden to trigger animation, runs opposite of our filtering
        this.productList.hidden = !newActive;
      }
      this.active = newActive;
      this.setAttribute("data-active", newActive);
    }
  }
  customElements.define("byo-facet", BYOFacet);
}

if (!customElements.get("byo-filter")) {
  class BYOFilter extends HTMLElement {
    constructor() {
      super();
      this.active = this.dataset.active && this.dataset.active != "false";
      this.filterValue = this.dataset.collection;
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }
    attachListeners() {
      this.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener(
        "byo-filter-changed",
        this.handleFilterChange.bind(this)
      );
    }
    handleFilterChange(e) {
      if (e?.detail.filterVal != this.filterValue) {
        this.updateActive(false);
      }
    }
    updateActive(newActive) {
      this.active = newActive;
      this.setAttribute("data-active", newActive);
    }
    handleClick() {
      if (!this.active) {
        this.updateActive(!this.active);
        document.dispatchEvent(
          new CustomEvent("byo-filter-changed", {
            detail: {
              filterVal: this.filterValue,
            },
          })
        );
      }
    }
  }
  customElements.define("byo-filter", BYOFilter);
}
